import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68e3b76c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_home" }
const _hoisted_2 = { class: "header_" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, "后台管理", -1))
const _hoisted_4 = { class: "header_" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-dropdown-link zt" }, " 主题 ", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("蓝色")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("黑色")
const _hoisted_8 = { class: "el-dropdown-link" }
const _hoisted_9 = { class: "flexAlign zt" }
const _hoisted_10 = { style: {"margin":"0 3px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("退出")
const _hoisted_12 = { class: "header_right" }
const _hoisted_13 = { style: {"width":"100%","overflow-x":"hidden"} }
const _hoisted_14 = { style: {"padding":"15px 15px 0 15px"} }

import {
		reactive,
		ref,
		onMounted,
		computed
	} from 'vue';
	import { useRoute,useRouter } from 'vue-router';
	import { 
		requestLoginOut,requestmenu,
		requesttheme,
		requestMyuser
	} from '@/api/api';
	import { ElMessage } from 'element-plus';
	
export default /*#__PURE__*/_defineComponent({
  name: 'Home',
  setup(__props) {

	const router = useRouter()
	const route = useRoute()
	const theme = ref<string>("")
	const editableTabsValue = ref<string>("")
	const isCollapse = ref<boolean>(false)
	const editableTabs = ref<any[]>([])
	const userList = ref<any>({})
	const navList = ref<any>([])
	onMounted(()=>{
		requestmenu().then((res:any)=>{
			if(res.status === 1){
				console.log(res.datalist);
				navList.value=res.datalist;	
				getMyUser()
			}else{
				ElMessage({
					message: res.msg,
					type: 'error',
					duration: 500
				});
				if(res.msg=="未登录或登录超时"){
					setTimeout(() => {
						router.push({
							path: '/'
						})
					}, 500)
				}
			}
		})
		// toClick({name:'修改密码',path:'/password'})
	})
	const navJs = computed(()=> {
		return function(){
			let navArr = {
				'/work':'1-1',
				'/weekrecordslist':'1-5',
				'/usergroup':'1-2',
				'/base':'1-3',
				'/taskplan':'1-4',
				'/project':'2-1',
				'/projectinternal':'2-6',
				'/projectfollowup':'2-2',
				'/projectfollowupxxts':'2-3',
				'/alltask':'3-1',
				'/tjfinishday':'3-10',
				'/tjjianmo':'3-11',
				'/jianmolist':'3-12',
				'/taskquery':'3-14',
				'/newtasklog':'3-2',
			'/user':'4-1',
			'/permissions':'4-2',
			'/department':'4-3',
			'/tasktypeconfig':'4-4-1',
			'/systemconfig':'4-4-2',
				'/projectweekstatuslist':'5-1',
				'/tjyuqiuser':'5-2',
				'/jlrwtj':'5-3',
				'/jlrwhz':'5-7',
				'/gjcstj':'5-4',
				'/formrejecttj':'5-10',
				'/jiashic':'5-5',
				'/projectstepstatuslist':'5-6',
				'/password':'10',
				'/updaterecord':'8-3',
			'/projectreport':'7-7',
				'/configlist3':'6-1',
				'/postsaleanalysislist':'6-2',
				'/postsaleanalysis':'6-3',
				'/postsaleanalysisfine':'6-4',
				'/complaintlist':'6-6',
				'/allbd':'7-1',
				'/selfbd':'7-2',
				'/formtemplate':'7-3',
								'/forminstancelist':'7-4',
								'/datacollecttemplate':'7-5',
								'/datacollectadd':'7-6',
								'/signformsummary':'7-8'
			}
			return navArr[route.path]
		}
	})
	const isBg = computed(()=>{
		return function(){
			let b = ''
			if(userList.value.field0 == "黑色"){
				b = "background-color:#545c64;"
			}else{
				b = "background-color:#409EFF;"
			}
			return b
		}
	})
	const getMyUser = () => {
		requestMyuser().then((res:any)=>{
			if(res.status === 1){
				userList.value = res.datalist[0]
			}else{
				ElMessage({
					message: res.msg,
					type: 'error',
					duration: 500
				});
				if(res.msg=="未登录或登录超时"){
					setTimeout(() => {
						router.push({
							path: '/'
						})
					}, 500)
				}
			}
		})
	}
	//数组去重
	const unique = (arr: any[]) => {
		const res = new Map();
		return arr.filter((arr) => !res.has(arr.title) && res.set(arr.title, 1))
	}
	// 菜单跳转
	const toClick = (v: any) => {
		console.log("v:",v);
		console.log("v.key:",v.key);
		console.log("v.path:",v.path);
		if(!v.key){
			console.log(11111);
			editableTabs.value.push({
				title: v.name,
				path: v.path,
				name: v.path
			})
			editableTabs.value = unique(editableTabs.value)
			editableTabsValue.value = v.path
			router.push({
				path: v.path,
				query:{
					a:"222",
					key:1,
					value:2
				}
			})
		}else{
			console.log(2222);
			editableTabs.value.push({
				title: v.name,
				path: v.path+"?key="+v.key,
				name: v.path
			})
			editableTabs.value = unique(editableTabs.value)
			editableTabsValue.value = v.path+"?key="+v.key
			router.push({
				path: v.path+"?key="+v.key,
				query:{
					a:"123",
					key:v.key,
					value:v.value
				}
			})
			
		}
	}
	const tabClick = (tab: any) => {
		router.push({
			path: tab
		})
	}
	//删除标签
	const handleTabsEdit = (targetName:any, action: any) =>{
		if (action === 'remove') {
			let tabs = editableTabs.value;
			let activeName = editableTabsValue.value;
			if (activeName === targetName) {
				tabs.forEach((tab, index) => {
					if (tab.name === targetName) {
						let nextTab = tabs[index + 1] || tabs[index - 1];
						if (nextTab) {
							activeName = nextTab.name;
						}
					}
				});
			}
			editableTabsValue.value = activeName;
			router.push({
				path: editableTabsValue.value
			})
			editableTabs.value = tabs.filter(tab => tab.name !== targetName);
			// console.log(editableTabsValue.value);
			// console.log(editableTabs.value);
		}
	}
	//更换主题
	const handleCommand = (command: string) => {
		theme.value = command
		requesttheme({field0:command}).then((res:any)=>{
			if (res.status === 1) {
				ElMessage.success("更换主题成功");
				getMyUser();
			}
		})
	}
	//折叠菜单
	const navopen = () => {
		isCollapse.value = !isCollapse.value
	}
	//退出
	const getAdmin = (command: string) => {
		if (command == "退出") {
			requestLoginOut().then((res: any)=>{
				if (res.status === 1) {
					ElMessage({
						message: '退出成功',
						type: 'success',
						duration: 500
					});
					setTimeout(() => {
						router.push({
							path: '/'
						})
					}, 500)
				} else {
					ElMessage.error(res.msg);
				}
			})
		}
	}
	// 刷新
	const refresh = () => {
		location.reload();
	}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Refresh = _resolveComponent("Refresh")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header_top",
      style: _normalizeStyle(_unref(isBg)())
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_icon, {
          size: 20,
          style: {"color":"#fff","cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (navopen()))
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(isCollapse.value?'Expand':'Fold')))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_dropdown, {
          style: {"margin-right":"20px"},
          onCommand: handleCommand
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "蓝色" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "黑色" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          href: "javascript:;",
          title: "刷新",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (refresh()))
        }, [
          _createVNode(_component_el_icon, {
            size: 18,
            style: {"color":"#fff","margin-right":"20px","margin-top":"2px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Refresh)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_dropdown, { onCommand: getAdmin }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "退出" }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_UserFilled)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_10, "你好，" + _toDisplayString(userList.value.name==""?'用户':userList.value.name), 1),
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CaretBottom)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ])
    ], 4),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_el_menu, {
        style: _normalizeStyle({height: '100%',boxShadow: '0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)'}),
        class: "el-menu-vertical-demo",
        collapse: isCollapse.value,
        "default-active": _unref(navJs)(),
        "unique-opened": true
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item.children.length>0)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 0,
                    index: item.index
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (v, i) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                          key: i,
                          index: v.index,
                          onClick: ($event: any) => (toClick(v))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(v.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["index", "onClick"])), [
                          [_vShow, v.show]
                        ])
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index"])), [
                    [_vShow, item.show]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: item.index,
                    onClick: ($event: any) => (toClick(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: 18 }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["index", "onClick"])), [
                    [_vShow, item.show]
                  ])
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["style", "collapse", "default-active"]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_tabs, {
            modelValue: editableTabsValue.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableTabsValue).value = $event)),
            type: "card",
            closable: "",
            onEdit: handleTabsEdit,
            onTabChange: tabClick
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableTabs.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: item.name,
                  label: item.title,
                  name: item.path
                }, null, 8, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}
}

})